import React, { useEffect } from 'react';

import { AppContext } from '../provider/AppContextProvider';
import { getPianoAid, getPianoScriptUrl } from '../helper/url';
import useScript from '../helper/useScript';
import Script from 'next/script'

declare global {
  interface Window {
    tikPianocheckoutCustomEvent: any;
    tikPianologinRequired: any;
    tikPianostartCheckout: any;
    tikPianocheckoutComplete: any;
    tikPianoinit: any;
  }
}

export default function PianoScript() {
  const status = useScript(`${getPianoScriptUrl()}?aid=${getPianoAid()}`)
  const { pianoInitialized, setPianoInitialized } = React.useContext(AppContext);

  const initPiano = () => {
      let tp = window["tp"] || [];
      if(!pianoInitialized) {
        setPianoInitialized(true)
        tp.push(["setAid", getPianoAid()]);
        if(process.env.NEXT_PUBLIC_APP_ENV != "production") {
          tp.push(["setSandbox", true]);
        }
        tp.push(["setUseTinypassAccounts", false]);

        tp.push(["addHandler", "checkoutCustomEvent", function(params) {
          if(window.tikPianocheckoutCustomEvent) {
            window.tikPianocheckoutCustomEvent(params)
          }
        }])

        tp.push(["addHandler", "loginRequired", function(params) {
          if(window.tikPianologinRequired) {
            window.tikPianologinRequired(params)
          }
        }]);

        tp.push(["addHandler", "startCheckout", function (params) {
          if(window.tikPianostartCheckout) {
            window.tikPianostartCheckout(params)
          }
        }]);

        tp.push(["addHandler", "checkoutComplete", function (conversion) {
          if(window.tikPianocheckoutComplete) {
            window.tikPianocheckoutComplete(conversion)
          }
        }]);

        tp.push(["addHandler", "init", function (conversion) {
          if(window.tikPianoinit) {
            window.tikPianoinit()
          }
        }]);

        // var cX = cX || { options: { consent: true } }; // TODO fixme
        // cX.callQueue = cX.callQueue || [];
        // cX.callQueue.push(['requireConsent']);
        // cX.callQueue.push(['invoke', function() {
        //   if (!cX.hasConsent('pv')) {
        //       cX.callQueue.push(['setConsent', { pv: true, segment: true, ad: true, recs: true }]);
        //   }
        // }]);
      }
      else {
        if(window.tikPianoinit) {
          window.tikPianoinit()
        }
      }
  }

  useEffect(() => {
    if (typeof window["tp"] !== 'undefined') {
      if(status === 'ready') {
        initPiano()
      }
    }
  }, [status])// eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {/* Queue vorbereiten und Callback registrieren */}
      <Script id="cx-setup" strategy="beforeInteractive">
        {`
          window.cX = window.cX || {};
          window.cX.callQueue = window.cX.callQueue || [];
          window.cX.callQueue.push(['invoke', function() {
            // console.log('** cx.js is loaded');
          }]);
        `}
      </Script>

      {/* cx.js asynchron laden */}
      {/* <Script
        id="cx-script"
        src="https://cdn.cxense.com/cx.js"
        strategy="afterInteractive"
      /> */}

      {/* <Script key="tinypass" id="tinypass" async src="https://code.piano.io/api/tinypass.min.js"></Script> */}
    </>)
}